module.exports = __webpack_public_path__ + "img/our-mission-bg-image-02.2a6c534d.png";